export default __webpack_public_path__ + "static/media/i.90ea17c2.svg";